var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.layout,{tag:"component",attrs:{"authorised":_vm.authorised}}),_c('dialogs-wrapper')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }